import axios from "axios";

// const baseURL = "http://47.114.126.75:11090"//正式
const baseURL = "https://api.bbkongjia.com"; //正式
// const baseURL = "http://192.168.1.119:11090" ///本地
export default {
  //保存文章
  saveArticle(data) {
    return axios
      .post(
        `${baseURL}/demo/insertnew`,
        data
        // { headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'},}
      )
      .then((res) => {
        return res;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  //修改文章444
  reviseArticle(data, id) {
    return axios
      .post(`${baseURL}/demo/insertnew?id=${id}`, data)
      .then((res) => {
        return res;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  // 获取文章信息
  getSingleArticle(param) {
    return axios({
      method: "get",
      url: `${baseURL}/demo/selectText`,
      params: param,
    })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  //进入详情后，拿到页面的数据
  newsDetailData(id) {
    return axios
      .get(`${baseURL}/demo/selectnewsclassification?id=${id}`)
      .then((res) => {
        return res;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  //获取最新id   新建文章中
  // getNewId(){
  //     return axios.get(`${baseURL}/demo/id`)
  //     .then(res =>{
  //         return res
  //     })
  //     .catch(error => {
  //         return Promise.reject(error);
  //     })
  // },

  //http://47.114.126.75:11090/demo/selectnewslist
  //获取已发文章列表
  getNewsListData(param) {
    return axios({
      url: `${baseURL}/demo/selectnewslist`,
      method: "get",
      params: param,
    })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  //删除文章
  deleteHandle(id, url) {
    return axios
      .delete(`${baseURL}/demo/deleteid?id=${id}&url=${url}`)
      .then((res) => {
        return res;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  //获取咨询信息   表单
  getConsultData() {
    return axios
      .get(`${baseURL}/demo/selectos`)
      .then((res) => {
        return res;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
};
